import ReactMarkdown from "react-markdown";
import { LegalTopBar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SITE_TERMS_MD } from "@/content/siteTerms";
import { SITE_PRIVACY_MD } from "@/content/sitePrivacy";

const mdComponents = {
  h2: (p) => (
    <h2 className="mt-12 font-display text-2xl font-semibold tracking-tight text-ink first:mt-0" {...p} />
  ),
  h3: (p) => <h3 className="mt-8 font-display text-lg font-semibold text-ink" {...p} />,
  p: (p) => <p className="mt-4 whitespace-pre-line font-body text-base leading-relaxed text-slate" {...p} />,
  ul: (p) => <ul className="mt-4 list-disc space-y-2 pl-6 font-body text-base leading-relaxed text-slate" {...p} />,
  ol: (p) => <ol className="mt-4 list-decimal space-y-2 pl-6 font-body text-base leading-relaxed text-slate" {...p} />,
  a: (p) => <a className="font-semibold text-growth underline underline-offset-4" {...p} />,
  strong: (p) => <strong className="font-semibold text-ink" {...p} />,
};

const LegalDocShell = ({ eyebrow, title, intro, markdown, testId }) => (
  <main className="bg-cream" data-testid={testId}>
    <LegalTopBar />
    <div className="grain relative overflow-hidden bg-evergreen text-white">
      <div className="mx-auto max-w-[860px] px-4 py-16 sm:px-6 lg:py-20">
        <p className="font-display text-xs font-semibold uppercase tracking-[0.22em] text-leaf">
          {eyebrow}
        </p>
        <h1 className="mt-3 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
          {title}
        </h1>
        {intro && (
          <p className="mt-5 max-w-[620px] font-body text-base leading-relaxed text-sage">{intro}</p>
        )}
      </div>
    </div>
    <div className="mx-auto max-w-[860px] px-4 py-16 sm:px-6 lg:py-20">
      <ReactMarkdown components={mdComponents}>{markdown}</ReactMarkdown>
    </div>
    <Footer />
  </main>
);

export const WebsiteTermsPage = () => (
  <LegalDocShell
    testId="site-terms-page"
    eyebrow="Build.Make.Win website"
    title="Terms of Use"
    intro="These Terms govern your use of the buildmakewin.com website. CoachER has its own product terms."
    markdown={SITE_TERMS_MD}
  />
);

export const WebsitePrivacyPage = () => (
  <LegalDocShell
    testId="site-privacy-page"
    eyebrow="Build.Make.Win website"
    title="Privacy Policy"
    intro="This policy covers the buildmakewin.com website. CoachER has its own product privacy policy."
    markdown={SITE_PRIVACY_MD}
  />
);
